<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="h-screen flex w-full bg-img">
		<div
			class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
		>
			<img src="@/assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4" />
			<h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">
				{{ $t("NotAuthorizedPage.Title") }}
			</h1>
			<p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse">
				{{ $t("NotAuthorizedPage.Subtitle") }}
			</p>
			<vs-button size="large" @click="handleBack()">{{
				listPermissions.length > 0 ? $t("NotAuthorizedPage.ButtonText") : $t("NotAuthorizedPage.LogOut")
			}}</vs-button>
		</div>
	</div>
</template>
<script>
import Api from "@/helpers/api.js";
import User from "@/models/User.js";
import IndexedDB from "@/helpers/IndexedDB.js";

export default {
	data() {
		return {
			fromRoute: null,
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.fromRoute = from;
		});
	},
	computed: {
		listPermissions() {
			return this.$store.state.permissionsCheck.serviroutes_permissions;
		},
	},
	methods: {
		handleBack(fallback) {
			if (this.listPermissions.length > 0) {
				this.$router.push("/dashboard/home");
			} else {
				this.logout();
			}
		},
		async logout() {
			this.$vs.loading();
			const usuario = new User();
			const user = await IndexedDB.first("users");

			/**
			 * Esto fixea un problema cuando el usuario quiere cerrar sesión,
			 * y la tabla en IndexDB exista sin informacion.
			 */
			if (user) {
				Api.delete("/auth/sessions/" + user.access_token).then(async (r) => {
					await usuario.clearUser();
					await IndexedDB.truncate("users", null);
					this.$router.push({name: "page-login"}).catch(() => {});
				});
			} else {
				await usuario.clearUser();
				await IndexedDB.truncate("users", null);
				this.$router.push({name: "page-login"}).catch(() => {});
			}
		},
	},
};
</script>
